/**
 * Created by dreamc_t on 2017/4/7.
 */
require('./sportMatch.scss');
var tmpl = require('./sportMatch.ejs');
var tmplMatchInfo = require('./matchInfo.ejs');
var tmplSupport = require('./support.ejs');

// 本地接口http://10.21.7.47:8099   线上http://api.livesports.ifeng.com
var apiDomain = '//api.livesports.ifeng.com';
var requestUrl = apiDomain + '/livesports/match/info'; // 志疆-通过赛事id获取赛事信息接口
var supportGetUrl = apiDomain + '/livesports/survey/surveyres'; // 投票获取接口
var supportPostUrl = apiDomain + '/livesports/survey/vote'; // 投票提交接口

var sportMatch = function (info) {
    this.sportMatchInfo = {};
    this.matchId = info.matchId;
    this.container = info.container;
    this.initDom();
    this.requestData();
    this.initEvent();
}
sportMatch.prototype.formatData = function (data) {
    data.ad = data.ad || '//p0.ifengimg.com/508df9aec9e2a/image/2018/05/28/15274917903605_240_80.png';// 默认足球
    return data;
}
sportMatch.prototype.updateSportMatch = function (newdata) {
    // console.log('updateSportMatch--', newdata);
    // 更新数据
    const last = this.sportMatchInfo;
    this.sportMatchInfo = Object.assign({}, last, this.formatData(newdata.data));

    // 重渲染
    $(this.el).find('.match-info').html($(tmplMatchInfo({ data: this.sportMatchInfo })));
    // 广告图, 替换 (上一次存在，则替换，不存在，则新增)
    newdata.data.ad && this.el.find('.ad img').attr('src', newdata.data.ad || '//p0.ifengimg.com/508df9aec9e2a/image/2018/05/28/15274917903605_240_80.png');

    // sid更新---获取投票
    if (newdata.sid && newdata.sid !== last.sid) {
        this.requestVote(this.sportMatchInfo.sid);
    }
}
sportMatch.prototype.getPercent = function (left, right) {
    var widthHt = '50%';
    var total = left + right;
    if (total !== 0) {
        var percent = Number.parseFloat(left / total).toFixed(2) * 100;
        widthHt = percent + '%';
    }
    return widthHt;
}
sportMatch.prototype.updateVoteNum = function (data) {
    const option = data.data.resultArray.option;
    this.el.find('.ht .support-num').html(option[0].num || 0);
    this.el.find('.vt .support-num').html(option[1].num || 0);
    // 支持率进度
    const widthHt = this.getPercent(option[0].num, option[1].num);
    this.el.find('.bar-progress').width(widthHt);
    if (this.sportMatchInfo.ad) {
        this.el.find('.ad').css('left', widthHt);
    }
}
sportMatch.prototype.requestVote = function (id) {
    var _this = this;
    // 获取投票数据
    $.ajax({
        url: supportGetUrl,
        type: 'get',
        cache: true,
        data: {
            surid: id,
            rt: 'jsonp'
        },
        dataType: 'jsonp',
        success: function (data) {
            // console.log('requestVote-success-data', data);
            if (data && data.code === 0) {
                const resultArray = data.data.resultArray;
                // 初始，记录主客队的id
                _this.el.find('.support-actions').attr('data-qid', resultArray.questionid || '');
                _this.el.find('.ht').attr('data-itemid', resultArray.option[0].itemid || '');
                _this.el.find('.vt').attr('data-itemid', resultArray.option[1].itemid || '');
                _this.updateVoteNum(data);
            } else {
                alert(data.message)
            }
        },
        error: function () {
            // console.log('requestVote-error-data');
            alert('获取投票数接口报错')
        }
    })
}

sportMatch.prototype.requestData = function () {
    var _this = this;
    // console.log('sportMatch--requestData');
    // 先请求赛事详情---再投票支持率
    $.ajax({
        url: requestUrl,
        type: 'GET',
        data: {
            mid: _this.matchId,
            rt: 'jsonp'
        },
        cache: true,
        dataType: 'jsonp',
        success: function (data) {
            if (data && data.code === 0) {
                _this.sportMatchInfo = _this.formatData(data.data || {});
                $(_this.el).find('.match-info').html($(tmplMatchInfo({ data: _this.sportMatchInfo })));
                $(_this.el).find('.match-support').html($(tmplSupport({ data: _this.sportMatchInfo })));
                // 获取投票数
                _this.sportMatchInfo.sid && _this.requestVote(_this.sportMatchInfo.sid);
            } else {
                alert(data.message)
            }
        },
        error: function (e) {
            // console.log('sportMatch--ajac---error', e);
            alert('体育赛事信息获取报错');
        }
    });
};
sportMatch.prototype.renderTo = function (parentNode) {
    if ($(this.el)[0]) {
        if (document.getElementsByClassName('top-box').length) {
            parentNode.parentNode.removeChild(document.getElementsByClassName('top-box')[0]);
        }
        parentNode.parentNode.insertBefore($(this.el)[0], parentNode.nextSibling);
    }
};
sportMatch.prototype.initDom = function () {
    this.el = $(tmpl({}));
    this.renderTo(this.container);
}
sportMatch.prototype.initEvent = function () {
    let _this = this;
    // 轮询获取支持率
    clearTimeout(_this.timerForSupport);
    this.timerForSupport = setTimeout(function () {
        const $supportGet = {
            url: supportGetUrl,
            type: 'get',
            data: {
                surid: _this.sportMatchInfo && _this.sportMatchInfo.sid || '',
                rt: 'jsonp'
            },
            cache: true,
            dataType: 'jsonp',
            success: function (data) {
                // console.log('requestVote-success-data', data);
                if (data && data.code === 0) {
                    _this.updateVoteNum(data);
                } else {
                    alert(data.message);
                }
            },
            error: function (e) {
                alert('获取投票数接口报错')
            },
            complete: function () {
                // 轮询请求
                clearTimeout(_this.timerForSupport);
                _this.timerForSupport = setTimeout(function () {
                    $.ajax($supportGet);
                }, 240000); // 4min
            }
        };
        $.ajax($supportGet);
    }, 240000); // 4min
    // 支持点击
    $(document).one('click', '.ht-support', function () {
        var self = this;
        // 样式改变-已支持
        !$(this).hasClass('ht-support-success') && $(this).addClass('ht-support-success');
        // 提交
        const postParams = {
            surid: $(this).closest('.support-actions').attr('data-sid') || '',
            qid: $(this).closest('.support-actions').attr('data-qid') || '',
            itemid: $(this).closest('.actions').attr('data-itemid') || '',
            rt: 'jsonp'
        };
        $.ajax({
            url: supportPostUrl,
            type: 'post',
            data: postParams,
            cache: true,
            dataType: 'jsonp',
            success: function (data) {
                // console.log('ht-support--ajac--post-success', data);
                if (data && data.code === 0) {
                    _this.updateVoteNum(data);
                } else {
                    alert(data.message);
                }
            },
            error: function (e) {
                // console.log('ht-support--ajac--post-err');
                alert('提交投票接口报错')
            }
        });
    })
    $(document).one('click', '.vt-support', function () {
        var self = this;
        // 样式改变-已支持
        !$(this).hasClass('vt-support-success') && $(this).addClass('vt-support-success');
        // 提交
        const postParams = {
            surid: $(this).closest('.support-actions').attr('data-sid') || '',
            qid: $(this).closest('.support-actions').attr('data-qid') || '',
            itemid: $(this).closest('.actions').attr('data-itemid') || '',
            rt: 'jsonp'
        };
        $.ajax({
            url: supportPostUrl,
            type: 'post',
            data: postParams,
            cache: true,
            dataType: 'jsonp',
            success: function (data) {
                // console.log('ht-support--ajac--post-success', data);
                if (data && data.code === 0) {
                    _this.updateVoteNum(data);
                } else {
                    alert(data.message);
                }
            },
            error: function (e) {
                // console.log('ht-support--ajac--post-err');
                alert('提交投票接口报错')
            }
        });
    })
}
sportMatch.prototype.clearSpoll = function (timer) {
    clearTimeout(timer);
}
module.exports = sportMatch;



// WEBPACK FOOTER //
// ./app/modules/sportMatch/index.js